const map = {
	"./account_center_logo.svg": 60561,
	"./account_center_only_logo.svg": 40406,
	"./arrow_blue_right.svg": 2107,
	"./arrow_dropdown_blue.svg": 62796,
	"./arrow_left.svg": 34583,
	"./checkbox_default.svg": 1599,
	"./checkbox_selected.svg": 2555,
	"./circle_bookshelf_sm.svg": 25577,
	"./circle_bookshelf_sm_hover.svg": 74444,
	"./circle_support.svg": 84536,
	"./circle_support_hover.svg": 30821,
	"./circle_support_sm.svg": 32317,
	"./circle_support_sm_hover.svg": 23696,
	"./devices.svg": 99523,
	"./error.svg": 50870,
	"./error_icon.svg": 63610,
	"./external_window.svg": 64696,
	"./external_window_white.svg": 43410,
	"./i_icon.svg": 62361,
	"./loader.svg": 21011,
	"./logo.svg": 2143,
	"./logo_ac.svg": 23308,
	"./mobile.svg": 3850,
	"./preferences.svg": 50698,
	"./radio_button_default.svg": 13030,
	"./radio_button_selected.svg": 67408,
	"./resources.svg": 12321,
	"./sign_out.svg": 18590,
	"./sort_icon.svg": 72664,
	"./success.svg": 30779,
	"./success_icon.svg": 92081,
	"./transactions.svg": 89725,
	"./user.svg": 79803,
	"./user_info.svg": 45132,
	"./vitalsource_color.svg": 88895
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20089;